// ======================================================================
// File Name       : item
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const ITEM_RECEIVE_ITEM_LIST = 'ITEM_RECEIVE_ITEM_LIST';
export const ITEM_INIT_DATA_FOR_DETAIL_EDIT_CONFIRM_DIALOG = 'ITEM_INIT_DATA_FOR_DETAIL_EDIT_CONFIRM_DIALOG';
export const ITEM_INIT_DATA_FOR_REGISTER_DIALOG = 'ITEM_INIT_DATA_FOR_REGISTER_DIALOG';
export const ITEM_RECIEVE_LINKING_CONTENT = 'ITEM_RECIEVE_LINKING_CONTENT';
export const ITEM_UPDATE = 'ITEM_UPDATE';
export const ITEM_CHANGE_DATA = 'ITEM_CHANGE_DATA';
export const ITEM_GET_THUMBNAIL_DEFAULT = 'ITEM_GET_THUMBNAIL_DEFAULT';
export const ITEM_GET_VIDEO_THUMBNAIL_DEFAULT = 'ITEM_GET_VIDEO_THUMBNAIL_DEFAULT';
export const ITEM_GET_DOCUMENT_THUMBNAIL_DEFAULT = 'ITEM_GET_DOCUMENT_THUMBNAIL_DEFAULT';
export const ITEM_SAVE_DETAIL_SETTING_STATE = 'ITEM_SAVE_DETAIL_SETTING_STATE';
